import { Component, Inject, OnInit, ChangeDetectorRef } from '@angular/core';
import { CellsComponent } from 'src/app/core/grid-renderer/cells/cells.component';
import { CustomDetailComponentComponent } from 'src/app/core/check/custom-detail-component/custom-detail-component.component';
import { AetSafetyDashboardService } from 'src/app/services/aet-safety-dashboard.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CommonConstant } from 'src/app/core/constant/common.constant';
import { FinalEditSafetyComponent } from 'src/app/core/check/final-edit-safety/final-edit-safety.component';
import { CloseEventComponent } from 'src/app/core/check/close-event/close-event.component';
import { ImagePopUpComponent } from 'src/app/core/check/image-pop-up/image-pop-up.component';
import { CommentRendererComponent } from 'src/app/core/grid-renderer/comment.grid-renderer';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
// import { Component, ChangeDetectorRef, AfterViewInit } from 'angular2/core'

@Component({
    selector: 'app-child-grid',
    templateUrl: './child-grid.component.html',
    styleUrls: ['./child-grid.component.scss'],
    standalone: false // NOSONAR
})
export class ChildGridComponent implements OnInit {
  heading = '';
  columnDefs: any;
  childData: any;
  context: any;
  displayRowData: any;
  defaultColDef: any = {
    flex: 1,
    resizable: true,
  };
  rowHeight = 60;
  successMessage: any;
  errorMessage: any;
  detailRowHeight:30
  // gridOptions: any = { enableCellTextSelection: true,tooltipShowDelay: 500,detailRowAutoHeight:false};

  constructor(private readonly cdr: ChangeDetectorRef,
     private readonly aetSafetyDashboardService : AetSafetyDashboardService,
    @Inject(MAT_DIALOG_DATA) public dataStore: any,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<ChildGridComponent>,
     private readonly  ngxUiLoaderService : NgxUiLoaderService
  ) {
    this.context = {
      componentParent: this,
    };
  }

  ngOnInit(): void {
    this.heading = this.dataStore.header
    this.columnDefs = [
      {
        headerName: 'TM Title',
        field: 'tmTitle',
        minWidth: 100,
        maxWidth: 120,
       autoHeight: true,
      },
      {
        headerName: 'Length Of service',
        field: 'lengthOfService',
        minWidth: 150,
        maxWidth: 170,
       autoHeight: true,
      },
      {
        headerName: 'Process',
        field: 'process',
        minWidth: 100,
        maxWidth: 120,
       autoHeight: true,
      },
      {
        headerName: 'Cause Of Incident',
        field: 'causeOfIncident',
        minWidth: 170,
        maxWidth: 300,
       autoHeight: true,
        cellStyle: { cursor: 'pointer' },
        cellRenderer: CommentRendererComponent
      },
      {
        headerName: 'SWF',
        field: 'swf',
        minWidth: 50, maxWidth: 60,
        cellRenderer: CellsComponent,
      },
      {
        headerName: 'SOP',
        field: 'sop',
        minWidth: 50, maxWidth: 60,
        cellRenderer: CellsComponent,
      },
      {
        headerName: 'ECG',
        field: 'ecg',
        minWidth: 50, maxWidth: 60,
        cellRenderer: CellsComponent,
      },
      {
        headerName: 'TM',
        field: 'tm',
        minWidth: 50, maxWidth: 60,
        cellRenderer: CellsComponent,
      },
      {
        headerName: 'LSA',
        field: 'lsa',
        minWidth: 50, maxWidth: 60,
        cellRenderer: CellsComponent,
      },
      {
        headerName: 'LP Initiated',
        field: 'lpCounterMeasures',
        minWidth: 235,
        maxWidth: 300,
       autoHeight: true,
        cellStyle: { cursor: 'pointer' },
        cellRenderer: CommentRendererComponent
      },
      {
        headerName: 'Description',
        field: 'description',
        minWidth: 280,
        maxWidth: 300,
       autoHeight: true,
        cellStyle: { cursor: 'pointer' },
        cellRenderer: CommentRendererComponent
      },
      {
        headerName: 'Action',
        field: 'childGridRenderer',
        cellRenderer: CustomDetailComponentComponent,
        minWidth: 90, maxWidth: 90,
       autoHeight: true,
      },
    ];
    this.ngxUiLoaderService.start(CommonConstant.loader);

    this.displayRowData = [];

    this.childGridCall();
  }

  childGridCall() {
    const requestbody = { safetyEventId: this.dataStore.safetyEventId };

    this.aetSafetyDashboardService?.childGridCall(requestbody)?.subscribe(
      (response) => {
        this.cdr.detectChanges();
        this.childData = response;
        const keys = ['ecg', 'lsa', 'sop', 'swf', 'tm'];
        const uniqueRows = this.childData.reduce((result, obj) => {
          const existingObj = result.find(
            (item) => item.reportId == obj.reportId // NOSONAR
          );

          if (!existingObj) {
            result.push(obj);
          } else {
            for (const key in obj) {
              if (keys.includes(key)) {
                if (obj[key] == 4) { // NOSONAR
                  existingObj[key] = obj[key];
                }
              }
            }
          }

          return result;
        }, []);
        this.displayRowData = uniqueRows;
        this.ngxUiLoaderService.stop(CommonConstant.loader);
      },
      (_error) => {
        this.ngxUiLoaderService.stop(CommonConstant.loader);
      }
    );
  }

  finalSafetyEdit(body) {
    const dialogRef = this.dialog.open(FinalEditSafetyComponent, {
      disableClose: true,
      width: '1006px',
      height: '448px',
      data: {
        data: body,
        header: 'Edit Final Safety Event',
        tmTitleDrpDown: this.dataStore.tmTitleDrpDown,
        losDrpDown: this.dataStore.losDrpDown,
        processDrpDown: this.dataStore.processDrpDown
      },
    });

    dialogRef.afterClosed()?.subscribe((result: any) => {
      this.errorMessage = null;
      this.successMessage = null;
      this.ngxUiLoaderService.stop(CommonConstant.loader);
      if (result.event == 'SaveEvent') { // NOSONAR
        if (result?.responseType == 'success') { // NOSONAR
          this.childGridCall();

          this.successMessage = 'Successfully updated Final Safety Event';
          setTimeout(() => {
            this.errorMessage = null;
            this.successMessage = null;
          }, 5000);
        } else {
          this.errorMessage = 'Updation failed';
          setTimeout(() => {
            this.errorMessage = null;
            this.successMessage = null;
          }, 5000);
        }
      }
      if (result.event == 'onDeletePress') { // NOSONAR
        this.deleteEvent(result.id);
      }
    });
  }

  deleteEvent(id) {
    const dialogRef = this.dialog.open(CloseEventComponent, {
      disableClose: true,
      width: '570px',
      height: '217px',
      data: {
        header: `Delete Event No. ${id}`,
        event: 'delete',
        id: id,
        description: `Deleting this event will be permanent, and cannot be reversed.
          Are you sure you want to delete this event?`,
      },
    });

    dialogRef.afterClosed()?.subscribe((result: any) => {
      this.errorMessage = null;
      this.successMessage = null;
      this.ngxUiLoaderService.stop(CommonConstant.loader);
      if (result?.event == 'SaveEvent') { // NOSONAR
        if (result?.data == 'success') { // NOSONAR
          this.dialogRef.close({ event: 'triedToDelete', result: 'success' });
          // this.refreshData()
          this.successMessage = 'successfully deleted';
          setTimeout(() => {
            this.errorMessage = null;
            this.successMessage = null;
          }, 5000); //this.constants.notificationMessageTime);
        }
        else if (result?.data == 'failure') { // NOSONAR
          this.dialogRef.close({ event: 'triedToDelete', result: 'failure' });
          // this.refreshData()
          this.errorMessage = 'unable to delete';
          setTimeout(() => {
            this.errorMessage = null;
            this.successMessage = null;
          }, 5000); //this.constants.notificationMessageTime);
        }
      }
    });
  }

  imagePopUp(body) {
    const dialogRef = this.dialog.open(ImagePopUpComponent, {
      disableClose: true,
      width: '570px',
      height: '473px',
      data: {
        data: body,
        header: 'image Upload Section',
      },
    });

    dialogRef.afterClosed()?.subscribe((result: any) => {
      this.ngxUiLoaderService.stop(CommonConstant.loader);
      if (result?.event == 'SaveEvent') { // NOSONAR
        if (result?.data == 'Success') { // NOSONAR
          // this.refreshData()
          this.successMessage = null; 
          setTimeout(() => {
            this.successMessage = null;
            this.errorMessage = null;
          }, 5000); //this.constants.notificationMessageTime);
        }
      }
    });
  }

  close(): void {
    this.dialogRef.close({});
  }
}
